import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { select, Store } from '@ngrx/store';
import { GCI140State } from '../../store';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { updatei140StepStatus, updateStepStatusToInitialState } from '../../store/actions/step-status-update.actions';
import { getStepStatusUpdate } from '../../store/selectors/step-status-update.selectors';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { StepStatusUpdatePayload } from '../../utility/services/stepStatusUpdate.service';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { map } from 'rxjs/internal/operators/map';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';
import { first } from 'rxjs/internal/operators/first';
import { GCI140Service } from 'src/app/services/gci140.service';
import { DashboardWidgetsService } from 'src/app/services/dashboard-widgets.service';
import { I140FileUploadConfiguration } from '../../../../data/models/i140UploadConfiguration';
import { AppServicesLibraryService } from 'app-services-library';


@Component({
  selector: 'app-submit-petition',
  templateUrl: './submit-petition.component.html',
  styleUrls: ['./submit-petition.component.scss']
})
export class SubmitPetitionComponent implements OnInit {

  @ViewChild('submitPetitionForm', { static: true }) submitPetitionForm: NgForm;
  disabledControls: boolean;
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;
  statusTypeList: any;

  submitPetition: {
    receiptDate: Date,
    receiptNumber: string,
    submissionAckno: string,
    submitResponseCode: string,
    submitResponseName: string
  };

  fileUploadConfigurations: I140FileUploadConfiguration;

  observableSubscription$ = new Subject();
  guardSubscription: any;
  showNext: boolean = false;
  showPrev: boolean = false;

  constructor(private store: Store<GCI140State>,
    private gcI140Service: GCI140Service,
    private toastr: ToastrService,
    private guard: DirtyFormGuard,
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
    private dashboardService: DashboardWidgetsService,
    private stepStatusUpdatePayloadCostruction: StepStatusUpdatePayload,
    private appServicesLibraryService: AppServicesLibraryService
    ) {
    this.submitPetition = {
      receiptDate: null,
      receiptNumber: '',
      submissionAckno: '',
      submitResponseCode: '',
      submitResponseName: ''
    };
    this.showNext = this.dynamicDialogConfig.data?.showNext; 
    this.showPrev = this.dynamicDialogConfig.data?.showPrev;
  }

  ngOnInit(): void {
    // Selector for step status update
    this.store.pipe(select(getStepStatusUpdate)).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
        this.store.dispatch(loadSubTaskDetails({ taskId: this.stepDetails.taskId }));
      }
    });
    this.getStatusype();
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
      this.stepDetails = data;
      this.getSubmitPetition();
      this.fileUploadConfigurations = Object.assign({}, {
        disableControls: this.disabledControls,
        isDocumentTypeRequired: false,
        isDocumentUploadRequired: true,
        isViewEnabled: true,
        isDownloadEnabled: true,
        isDeleteEnabled: true,
        getApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/TRACKRCPT`,
        postApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/TRACKRCPT/fileCategory`,
        deleteApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/`,
        documentTypeDropdownCode: 'TRACKRCPT '
      })
      this.toggleControlsStatus();
    });
    this.submitPetitionForm.form.valueChanges.pipe(
      map(() => this.submitPetitionForm.dirty),
    ).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
      if (dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });

  }

  getStatusype() {
    this.dashboardService.getStatusAndResponse('SUBPET').subscribe((response) => {
      this.statusTypeList = response['response'] && response['response'].filter(ele => ele.stepResponseCode === 'SUBMITTED');
    });
  }

  getSubmitPetition() {
    this.gcI140Service.getReceiptDetails(this.dynamicDialogConfig.data.superTaskId,
      this.dynamicDialogConfig.data.subTaskId, this.dynamicDialogConfig.data.i140CaseId).subscribe((response: ImagilityBaseResponse) => {
        if (response) {
          this.submitPetition = response.data;
        }
      });
    this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
  }

  postsubmitPetition() {
    const submitPayload = {
      benchMarkActionCode: "",
      endDate: "",
      isAttorneyNotify: 0,
      isBeneficiaryNotify: 0,
      isPetitionerNotify: 0,
      receiptCategory: "",
      receiptDate: "",
      receiptNumber: this.submitPetition.submissionAckno,
      receiptType: "",
      responseCode: this.submitPetition.submitResponseCode,
      responseNote: "",
      reviewCode: "",
      reviewNote: "",
      startDate: "",
      statusCode: "",
      stepNote: "",
    }

    this.gcI140Service.postActionCode(this.dynamicDialogConfig.data.subTaskId, this.stepDetails.stepActionList[0].layoutCode, submitPayload).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
        this.submitPetitionForm.resetForm();
        if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
          this.updateStepStatus('INPROGRESS');
        }
        this.getSubmitPetition();
      }
    })
  }

  updateStepStatus(status) {
    this.store.dispatch(updatei140StepStatus({ payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status), subTaskId: this.stepDetails.taskId, actionCode: this.stepDetails.stepActionList[0].layoutCode }));
  }

  //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    this.fileUploadConfigurations = Object.assign({}, {
      disableControls: this.disabledControls,
      isDocumentTypeRequired: false,
      isDocumentUploadRequired: true,
      isViewEnabled: true,
      isDownloadEnabled: true,
      isDeleteEnabled: true,
      getApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/TRACKRCPT`,
      postApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/TRACKRCPT/fileCategory/`,
      deleteApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/`,
      documentTypeDropdownCode: 'TRACKRCPT '
    });
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  handleCancel() {
    this.getSubmitPetition();
  }

  handleClose() {
    this.guardSubscription = this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.dynamicDialogRef.close();
      }
      else {
        return false;
      }
    });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }
}
